const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const endpoints = {
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    logout: `${API_BASE_URL}/auth/logout`,
  },
  queries: {
    datasets: `${API_BASE_URL}/query/datasets`,
    tables: `${API_BASE_URL}/query/tables/`,
    columns: `${API_BASE_URL}/query/columns/`,   
    advancePreview: `${API_BASE_URL}/advance/query/preview`,
    advanceGroupPreview: `${API_BASE_URL}/advance/query/group/preview`,
    advanceGroupDirectPreview: `${API_BASE_URL}/advance/query/group/directPreview`,
    advanceSaveQuery: `${API_BASE_URL}/advance/query/save`,
    advanceSavedQuery: `${API_BASE_URL}/advance/query/get/`,
    advanceDeleteSavedQuery: `${API_BASE_URL}/advance/query/delete/`,
    advanceSavedQueries: `${API_BASE_URL}/advance/query/list`,
  },
  activation: {
    segmentList: `${API_BASE_URL}/activation/segments/list`, 
    segmentStatusUpdate: `${API_BASE_URL}/activation/segments/update/status`, 
    segmentUpdateDestination: `${API_BASE_URL}/activation/segments/update/destination`, 
    segmentDelete: `${API_BASE_URL}/activation/segments/delete` ,
    segmentCreate: `${API_BASE_URL}/activation/segments/create` 
  },
  glossary: {
    fetch: `${API_BASE_URL}/glossary/search`
  },
};

export default endpoints;
